export default __webpack_public_path__ + "static/media/about.17872b80.JPG";